/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
import * as Cesium from "cesium";
import React from "react";
import usePanoramaPopupStore from "../stores/usePanoramaPopupStore";
import useViewerStore from "../stores/useViewerStore";

export default function usePanoramaClick() {
  const { viewer, setPhase } = useViewerStore();

  const [pinClickHandler, setFinClickHandler] =
    React.useState<Cesium.ScreenSpaceEventHandler | null>(null);

  const { setId, setImageUrl, openPopup, isOpen, closePopup, setPanoramaUrl } =
    usePanoramaPopupStore();

  React.useEffect(() => {
    if (!viewer) {
      return;
    }
    setFinClickHandler(new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas));

    // eslint-disable-next-line consistent-return
    return () => {
      setFinClickHandler(null);
    };
  }, [setFinClickHandler, viewer]);

  React.useEffect(() => {
    let beforeClick: { id: { billboard: { color: Cesium.Color } } } | null =
      null;
    if (pinClickHandler && viewer) {
      pinClickHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      pinClickHandler.setInputAction((click: any) => {
        const pickedObject = viewer.scene.pick(click.position);
        if (!pickedObject || !pickedObject.id) return;

        // eslint-disable-next-line prefer-destructuring
        try {
          const { properties } = pickedObject.id;
          // eslint-disable-next-line no-underscore-dangle
          const p = properties._view._value.position;

          const cameraH = properties._cameraHeight
            ? properties._cameraHeight._value
            : // : p[2] + zRatio;
              p[2];

          const changePosition = Cesium.Cartesian3.fromDegrees(
            p[0],
            p[1],
            cameraH,
          );

          if (properties) {
            const { orientation } = properties._view._value;
            setPhase({
              // position,
              // orientation,
              position: [changePosition.x, changePosition.y, changePosition.z],
              orientation: {
                // heading: Cesium.Math.toRadians(properties.heading),
                // pitch: Cesium.Math.toRadians(-13),
                // roll: 0.0,
                heading: Cesium.Math.toRadians(orientation.heading),
                pitch: Cesium.Math.toRadians(orientation.pitch),
                roll: Cesium.Math.toRadians(orientation.roll),
              },
            });

            if (beforeClick) {
              beforeClick.id.billboard.color = Cesium.Color.WHITE;
            }

            pickedObject.id.billboard.color = Cesium.Color.SKYBLUE;
            beforeClick = pickedObject;
          }
          setId(properties._index._value);
          setImageUrl(properties._img._value);
          setPanoramaUrl(properties._url._value);
          openPopup();
        } catch (e) {
          console.log(e);
        }

      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

      // 회수(제거) 로직
      return () => {
        pinClickHandler.removeInputAction(
          Cesium.ScreenSpaceEventType.LEFT_CLICK,
        );
      };
    }
    // 회수(제거) 로직
    return () => {};
  }, [
    closePopup,
    isOpen,
    openPopup,
    pinClickHandler,
    setId,
    setImageUrl,
    setPanoramaUrl,
    setPhase,
    viewer,
  ]);

  return { pinClickHandler };
}
